import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { FlexColAlignStart } from 'components/primitives/flex';
import styled from 'styled-components';
import Button from 'components/ui/Button/Button';
import { isAnyFilterActiveAtom, resetAllFiltersAtom } from './Filter/filterStore';

export default function EmptyResultsMessageWithReset() {
  const isAnyFilterActive = useAtomValue(isAnyFilterActiveAtom);
  const resetAllFilters = useResetAtom(resetAllFiltersAtom);

  const emptySubCopy = isAnyFilterActive ? 'Try refining your search. ' : 'Try searching in another area. ';

  return (
    <Container gap="2em" mt="2em" pl="16px">
      <span>{emptySubCopy}</span>
      {isAnyFilterActive && <Button variant="renter" text="Clear search" outline onClick={resetAllFilters} />}
    </Container>
  );
}

const Container = styled(FlexColAlignStart)``;
